@if (dataLoaded()) {
  <div class="stu-document-detail">
    <div class="pre-page">
      <h1 class="heading-text">
        <a (click)="onBack()"><i class="fa fa-chevron-left"></i></a>活動記録詳細
      </h1>
    </div>
    @if (isDocumentRecord()) {
      <div class="segments">
        <app-segment-view [tabOptions]="tabOptions" [tabBadge]="tabBadge" (switchTab)="switchTab($event)"></app-segment-view>
      </div>
    }
    @if (isQuestionnaireRecord()) {
      <div class="block-info">
        <div class="row">
          <div class="col-md-9 col-xs-9 block-time">
            <p>作成日時：{{ activityRecord?.created_at }}</p>
            @if (!!activityRecord?.updated_at) {
              <p>最終更新：{{ activityRecord?.updated_at | date: 'yyyy/MM/dd HH:mm' }}</p>
            }
            <p>［アンケート］</p>
          </div>
          @if (canEditQuestionnaire()) {
            <div class="col-md-3 col-xs-3" (click)="onEditRecord()">
              <div class="block-edit pull-right">
                <i class="fa fa-pencil"></i>
                <a class="edit">編集</a>
              </div>
            </div>
          }
        </div>
      </div>
      <app-questionnaire-detail-student [questionnaire]="activityRecord.record"></app-questionnaire-detail-student>
    }
    @if (isDocumentRecord()) {
      @switch (currentTab) {
        @case ('self') {
          <div class="block-info">
            <div class="block-time">
              <p>作成日時：{{ activityRecord?.created_at }}</p>
              @if (!!activityRecord?.updated_at) {
                <p>最終更新：{{ activityRecord?.updated_at | date: 'yyyy/MM/dd HH:mm' }}</p>
              }
              @if (activityRecord?.is_answer) {
                <p>［課題］</p>
              }
            </div>
            <div class="block-actions">
              <label class="spen-mod-select" [class.is-selecting]="isShowDropdownActions">
                <button class="spen-mod-btn is-default dropdown-toggle" (click)="isShowDropdownActions = !isShowDropdownActions">
                  <p class="{{ getDevice() }}">&#9679;&#9679;&#9679;</p>
                </button>
                <div class="image-select-box">
                  <ul class="option-list">
                    @if (canEditRecord()) {
                      <li (click)="onEditRecord()">{{ activityRecord.is_answer ? '編集' : '編集・削除' }}</li>
                    }
                    <li (click)="onPublishRecord()">公開設定</li>
                  </ul>
                </div>
              </label>
            </div>
          </div>
          <app-document-detail-student
            [document]="activityRecord?.record"
            [categoryName]="activityRecord?.category_name"
            [isCompassAnswer]="activityRecord?.is_compass_answer"
            [workType]="activityRecord?.work_type"
            [marks]="activityRecord?.marks"
            [document_answers]="activityRecord.record.document_answers"
          >
          </app-document-detail-student>
          @if (canShowAdditionalInfoSection()) {
            <div class="block-standard">
              @if (activityRecord?.albums?.length > 0) {
                <div class="block-standard-child">
                  <p class="title">アルバム</p>
                  @for (album of activityRecord.albums; track album.id; let last = $last) {
                    <a class="spen-util-link" [routerLink]="['/albums/student', album.id]">{{ album.title }}</a>
                    @if (!last) {
                      <span> / </span>
                    }
                  }
                </div>
              }
              @if (this.activityRecord.is_answer) {
                <div class="block-standard-child">
                  @if (!!workPath) {
                    <p class="title">課題</p>
                    <a id="parent-work" class="spen-util-link" routerLink="{{ workPath }}" [queryParams]="{ isShowAnswer: false }">{{
                      activityRecord?.work_name
                    }}</a>
                  } @else {
                    <span id="parent-work">※課題は削除されました</span>
                  }
                </div>
              }
              @if (activityRecord?.public_spaces?.length > 0) {
                <div class="block-standard-child">
                  <p class="title">自主公開</p>
                  @for (space of activityRecord.public_spaces; track space.id; let last = $last) {
                    <a class="spen-util-link" [routerLink]="['/spaces/student', space.id]">{{ space.name }}</a>
                    @if (!last) {
                      <span> / </span>
                    }
                  }
                </div>
              }
              @if (activityRecord.pickups && activityRecord.pickups.length > 0) {
                <div class="block-standard-child">
                  <p class="title">ピックアップ</p>
                  @for (pickup of activityRecord.pickups; track pickup.id) {
                    <div class="list-pickup">
                      <app-pickup-item-toggle [pickup]="pickup"></app-pickup-item-toggle>
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
        @case ('cross_assessment') {
          <app-student-cross-assessments [crossAssessments]="activityRecord.cross_assessments"> </app-student-cross-assessments>
        }
        @case ('teacher_assessment') {
          <h2 class="assessments-header">先生からのコメント</h2>
          @for (assessment of activityRecord.assessments; track assessment.id; let isFirst = $first) {
            @switch (assessment !== edittingAssessment) {
              @case (true) {
                <app-student-assessment-detail
                  [assessment]="assessment"
                  [canEdit]="canEditAssessment(assessment)"
                  [isFirst]="isFirst"
                  (editAssessment)="onEditAssessment(assessment)"
                >
                </app-student-assessment-detail>
              }
              @case (false) {
                @if (isOwnerRecord()) {
                  <app-assessment-form-student
                    [activityRecordId]="activityRecord?.id"
                    [assessment]="assessment"
                    (cancelEditAssessment)="onCancelEditAssessment()"
                    (updateOldAssessment)="onUpdateOldAssessment($event, assessment)"
                    (deleteOldAssessment)="onDeleteOldAssessment(assessment)"
                  >
                  </app-assessment-form-student>
                }
              }
            }
          }
          @if (isOwnerRecord() && !edittingAssessment) {
            <app-assessment-form-student [activityRecordId]="activityRecord?.id" (saveNewAssessment)="onsaveNewAssessment($event)">
            </app-assessment-form-student>
          }
        }
      }
    }
    <div class="block-last">
      <button class="spen-mod-btn" (click)="onBack()">戻る</button>
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}

@if (showPublishActivityModal) {
  <app-publish-activity-modal
    [activityRecordId]="activityRecord.id"
    [publishedSpaces]="activityRecord.public_spaces"
    (eventClosePublishActivityModal)="closePublishActivityModal()"
    (eventPublishedToSpaces)="publishedToSpaces($event)"
  >
  </app-publish-activity-modal>
}
